import { Link } from "react-router-dom";
import { ROUTES } from "@/routes";
import { useCompanyNames } from "./useCompanyNames";
import styles from "./FirmChip.module.css";

export type FirmChipProps = {
  /**
   * Address-book company UUID. Numeric values are accepted for legacy call
   * sites only; new callers should pass the UUID so the chip links to the
   * UUID-keyed FirmDetail page and `useCompanyNames` can resolve via the
   * address-book endpoint that accepts UUIDs.
   */
  companyId: string | number;
  name?: string;
  className?: string;
};

export function FirmChip({ companyId, name, className }: FirmChipProps) {
  const id = String(companyId);
  const names = useCompanyNames(name ? [] : [id]);
  const resolved = name ?? names[id] ?? `Firm ${id}`;

  return (
    <Link
      to={ROUTES.profiles.firmDetail(id)}
      className={className ? `${styles.link} ${className}` : styles.link}
    >
      {resolved}
    </Link>
  );
}
